module.exports = __webpack_public_path__ + "img/home-book-landing-cover.cb47959e.png";